// These are used to store the selected media devices in localStorage
export const SELECTED_AUDIO_INPUT_KEY = "LiveKit-selectedAudioInput";
export const SELECTED_AUDIO_OUTPUT_KEY = "LiveKit-selectedAudioOutput";
export const SELECTED_VIDEO_INPUT_KEY = "LiveKit-selectedVideoInput";
